import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorFallback } from './errorFallback';

const ErrorBoundaryWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <ErrorBoundary fallback={<ErrorFallback />}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;